<script>
import { onMounted, onBeforeUnmount } from 'vue';

import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue';

export default {
  name: 'InterstitialScreen',

  components: {
    SwordButtonWuk,
  },

  props: {
    title: {
      type: String,
      default: undefined,
    },
    subtitle: {
      type: String,
      default: undefined,
    },
    disclaimer: {
      type: String,
      default: undefined,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    loading: Boolean,
  },

  setup(props, { emit }) {
    function emitNextEvent() {
      emit('next');
    }

    onMounted(() => {
      window.addEventListener('popstate', emitNextEvent);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('popstate', emitNextEvent);
    });

    return {
      emit,
    };
  },
};
</script>

<template>
  <div class="wrapper">
    <header class="header center">
      <h1
        v-if="title"
        class="header__title h2 -t_bold"
      >
        {{ $t(title) }}
      </h1>

      <h2
        v-if="subtitle"
        :key="subtitle"
        class="header__subtitle h6"
        v-html="$t(subtitle)"
      >
      </h2>
    </header>

    <main>
      <img
        v-if="imageUrl"
        class="content__image"
        :src="imageUrl"
        alt="Illustration Image"
      >

      <div class="container">
        <p
          v-if="disclaimer"
          class="content__disclaimer -t_regular"
        >
          {{ $t(disclaimer) }}
        </p>

        <sword-button-wuk
          class="content__btn"
          :text="$t('onboarding_button_continue')"
          theme="primary"
          size="large"
          :loading="loading"
          @click.native="emit('next')"
        >
        </sword-button-wuk>
      </div>
    </main>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  max-width: 640px;
}

.header {
  color: $context-color-1;
  margin: $space-lg 0;

  &__title {
    margin: map-get($sh-spacers-wuk, 0);
    white-space: pre-line;
  }

  &__subtitle {
    margin-top: $space-md;

    > span {
      @extend %-t_bold;
      text-transform: uppercase;
    }

    :deep(span.highlight-text) {
      color: $color-primary-500;
    }
  }

  &.center {
    text-align: center;
  }
}

.content {
  &__image {
    width: 100%;
  }

  &__disclaimer {
    @extend %t4;
    color: $color-grey-800;
    margin: 0;
  }

   &__btn {
    width: 100%;

    @media screen and (min-width: $tablet-size) {
      width: auto;
      min-width: 12.5rem;
    }
   }
}

.container {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: $space-xl;
  margin-top: $space-md;
  text-align: center;
}
</style>
